<template>
  <div class="featured-article pb-4">
    <div class="card card-scroll box-shadow article-align-center">
      <div class="grid-thumb position-relative">
        <div class="automation-news-article-image">
          <img class="img-fluid article-image ls-is-cached lazyload" :data-src="article.img_main" :alt="article.article_title" width="680" height="384" data-lazy="Article - Image - Main - Placeholder">
        </div>
      </div>
      <div class="d-flex flex-column article-info-container">
        <div class="article-info pb-3 pb-lg-3 pb-md-2 d-flex align-items-center justify-content-between justify-content-md-start">
          <div class="article-author d-flex align-items-center">
            <div class="author-img">
              <img class="ls-is-cached lazyload" :data-src="article.author.author_image" width="30" height="30" >
            </div>
            <div class="author-name pl-2">
              <a :href="article.author.path" v-if="article.author.path">
                {{article.author.display_name}}
              </a>

              <span v-else>
                {{article.author.display_name}}
              </span>
            </div>
          </div>
          <div class="article-reading-time pl-md-4 pr-2 pr-md-0">
            {{article.read_time}} {{article.read_time_label}}
          </div>
        </div>
        <div class="article-title pb-2 pb-lg-2 pb-md-1">
          <a :href="article.path" class="stretched-link">
            {{article.article_title}}
          </a>
        </div>
        <div class="article-short-description">
          {{article.short_description}}
        </div>
        <div class="article-footer row">
          <div class="col-12 footer-item publish-date">
            {{article.time_ago}}
            <span class="" v-if="article.country_name">| {{article.country_name}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'article-featured',
  props: {
    article: {
      required: true,
    },
  },
  mounted() {},
};
</script>
